"use client";

import { Image } from "antd";
import { useContext } from "react";
import { ImageBlock } from "rivals/shared/interfaces/Content";
import styles from "./LightBox.module.scss";
import { LightBoxContext } from "./context";

function Lightbox({
  imageBlocks
}: {
  imageBlocks: ImageBlock[];
}): React.JSX.Element {
  const { visible, setVisible, setCurrent, current } = useContext(
    LightBoxContext
  );

  return (
    <Image.PreviewGroup
      items={imageBlocks.map(imageBlock => imageBlock.data.largeUrl)}
      preview={{
        current,
        onChange: setCurrent,
        onVisibleChange: () => setVisible(!visible),
        rootClassName: styles.lightBoxRoot,
        visible
      }}
    />
  );
}

export default Lightbox;
